import { constants } from "../../misc/constants";
import Scenario1 from "./Scenario1";
import { SbarUIConfig } from "../../components/ui/SbarUI";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario1Part2 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-1-1',
        chapterCinematic18: 'medsurg-cinematic-1-18', //CAN BE REPLACED
        chapterCinematic20: 'medsurg-cinematic-1-20',
		chapterCinematic21: 'medsurg-cinematic-1-21',
        chapterCinematic22: 'medsurg-cinematic-1-22',
        chapterCinematic23: 'medsurg-cinematic-1-23',
        chapterCinematic24: 'medsurg-cinematic-1-24',
        chapterCinematic25: 'medsurg-cinematic-1-25',
        chapterCinematic26: 'medsurg-cinematic-1-26',
		chapterCinematic19: 'medsurg-cinematic-1-57', // sweaty gown loop
		chapterCinematic58: 'medsurg-cinematic-1-58',
		chapterCinematic60: 'medsurg-cinematic-1-60',
		chapterCinematic61: 'medsurg-cinematic-1-61',
		chapterCinematic64: 'medsurg-cinematic-1-64',
		chapterCinematic65: 'medsurg-cinematic-1-65',
		chapterCinematic66: 'medsurg-cinematic-1-66',
		chapterCinematic67: 'medsurg-cinematic-1-67',
		chapterCinematic68: 'medsurg-cinematic-1-68',
		chapterCinematic69: 'medsurg-cinematic-1-69',
		chapterCinematic70: 'medsurg-cinematic-1-70',
	}

	constructor(scenario: Scenario1, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private ActionInstanceID2: string;
	private ActionInstanceID3: string;
	private MoveInstanceID: string;

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Talk3: boolean = false;
	private Talk4: boolean = false;
	private Talk5: boolean = false;
	private Talk6: boolean = false;
	private Talk7: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action3: boolean = false;
	private Action4: boolean = false;
	private Action5: boolean = false;
	private Action6: boolean = false;
	private Action11: boolean = false;
	private Action12: boolean = false;
	private Action13: boolean = false;
	private Action14: boolean = false;
	private Action15: boolean = false;
	private Action21: boolean = false;
	private Action22: boolean = false;
	private Action23: boolean = false;
	private Action24: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	private PAbool: boolean = false;


	public get partId(): string {
		return constants.scenarios.scenario1.parts.level1Part2.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario1/video1' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario1/video10.mp4'];
	}

	public start() {
		const context = this;
		this.RememberDisplayed = false;

		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
			title: 'Vitals - On Admission'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
			list: '<li>Temperature: 98.5</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
			list: '<li>Pulse: 90</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
			list: '<li>Respirations: 20</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
			list: '<li>Blood Pressure: 140/90</li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
			list: '<li>Oxygen Saturation: 100% 2L of O2 nasal cannula </li>',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
			title: 'Vitals - 08:00',
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
			visit: context.scenario.visit1,
			lineBreak: true,
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcBasicID, {
			title: 'Patient Information',
			description: '<ul style=\"list-style-type:square\"><li>Ms. Nancy McLoughlin, age 49, a female, Caucasian patient was transported to the ED following a Motor Vehicle Accident (MVA). The patient initially presented with severe abdominal pain and pale color. As abdominal distention increased in addition to nausea and vomiting, an exploratory laparoscopy with a splenectomy was performed.</li><li>Patient received 2 units of packed red blood cells in the OR; HGB was 7; HCT was 22.</li><li>Patient admitted to MS/Telemetry unit following surgery.</li><li>Patient had moderate abdominal distention following surgery.</li><li>Patient is receiving Normal Saline infusion at 100ml/hr.</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcBasicID, {
			title: 'Patient History',
			description: '<ul style=\"list-style-type:square\"><li>Patient hypertension is being controlled with medication.</li><li>Caucasian</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcBasicID, {
			title: 'Active Medications',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcBasicID, {
			title: 'Providers Orders',
			description: '<ul style=\"list-style-type:square\"><li>Promethazine suppository as needed</li><li>Normal saline infusion rate of 100 ml/hr</li><li>IV of Hydromorphone for post-op pain</li><li>Acetaminophen as needed</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcBasicID, {
			title: 'Dietary Restrictions',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcBasicID, {
			title: 'Other Observations',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcBasicID, {
			title: 'Post-Op Information',
			description: '<ul style=\"list-style-type:square\"><li>NA</li></ul>'
		});

		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		context.scenario.hideFooter();
        this.scenario.displayModalPop(
			null,
            'Skipping to part 3',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.destroyAllUIInstances();
        var context = this;
		context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            'You have a new patient to visit in room 3',
            () => {
                this.scenario.stopAmbientLoop();
				this.scenario.playAmbientLoop(this.scenario.audioRoom);
				context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				this.playVideoChapter(this.chapterIds.chapterCinematic58, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				};
				this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '7', '9', false, false);
				context.TalkCount = 7;
				context.ActionCount = 9;
				context.getFooterCounts();
				setTimeout(() => {
					
				})
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeOut();
		context.scenario.displayDebrief(7000, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
			title: 'Vitals - 13:30'
		});
		this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
			visit: context.scenario.visit2,
			lineBreak: true
		});
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.onDone();
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.PatientRecordUI, {
            top: [
				{
					description: 'Name: Nancy McLoughlin'
				},
				{
					description: 'Room: #3'
				},
				{
					description: 'Age: 49'
				},
				{
					description: 'Sex: Female'
				}
			],
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).mcBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).mcNursesID),
			lab: [
				{
					title: 'Test Name',
					description1: 'BUN',
					description2: '<div aria-label="8.5 m g over d L">8.5 mg/dL</div>',
					description3: '<div aria-label="8 to 26">8 - 26</div>'
				},
				{
					title: 'Results',
					description1: 'Creatine',
					description2: '<div aria-label="0.7 m g over d L">0.7 mg/dL</div>', // 7 change to 9 for down arrow
					description3: '<div aria-label="0.7 to 1.2">0.7 - 1.2</div>'
				},
				{
					title: 'Normal Range',
					description1: 'Sodium',
					description2: '<div style="color: red" aria-label="132 m m o l over L. down">132 mmol/L <span style="float: right">&#129139;</span></div>',
					description3: '<div aria-label="136 to 145">136 - 145</div>'
				},
				{
					description1: 'Potassium',
					description2: '<div style="color: red" aria-label="3.2 m m o l over L. down"> 3.2 mmol/L <span style="float: right">&#129139;</span></div>',
					description3: '<div aria-label="3.5 to 5.1">3.5 - 5.1</div>'
				},
				{
					description1: 'Chloride',
					description2: '<div style="color: red" aria-label="84 m m o l over L. down"> 84 mmol/L <span style="float: right">&#129139;</span></div>',
					description3: '<div aria-label="98 to 107">98 - 107</div>'
				},
				{
					description1: 'Glucose',
					description2: '<div aria-label="80 m g over d L">80 mg/dL</div>',
					description3: '<div aria-label="74 to 106">74 - 106</div>'
				},
				{
					description1: 'HGB',
					description2: '<div style="color: red" aria-label="10 g over d L. down"> 10 g/dL <span style="float: right">&#129139;</span></div>',
					description3: '<div aria-label="13.5 to 17.9">13.5 - 17.9</div>'
				},
				{
					description1: 'HCT',
					description2: '<div style="color: red" aria-label="30 g over d L. down"> 30 g/dL <span style="float: right">&#129139;</span></div>',
					description3: '<div aria-label="41 to 54">41 - 54</div>'
				}
			],
			vitals: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).mcVitalsID),
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			} 
		});

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario1).PrMcID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: 'On a scale of 0-10, can you rate your pain?',
					onClicked: () => {
						this.segment1TalkRate();
					},
					disable: () => this.Talk2
				},
				{
					toppx: '250px',
					titletext: 'Can you describe your pain?',
					onClicked: () => {
						this.segment1TalkDescribe();
					},
					disable: () => this.Talk3
				},
				{
					toppx: '350px',
					titletext: 'Would you like something for the pain?',
					onClicked: () => {
						this.segment1TalkForPain();
					},
					disable: () => this.Talk4
				},
				{
					toppx: '450px',
					titletext: "Do you know where you are?",
					onClicked: () => {
						this.segment1TalkWhere();
					},
					disable: () => this.Talk5
				},
				{
					toppx: '550px',
					titletext: 'Do you know what day it is?',
					onClicked: () => {
						this.segment1TalkDay();
					},
					disable: () => this.Talk6
				},
				{
					toppx: '650px',
					titletext: "Do you remember what procedure you had done?",
					onClicked: () => {
						this.segment1TalkWhat();
					},
					disable: () => this.Talk7
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment1ActionVitals();
					},
					disable: () => this.Action1
				},
				{
					toppx: '150px',
					titletext: 'Assess Patient',
					onClicked: () => {
						this.segment1ActionAssess();
					},
					disable: () => this.Action2
				},
				{
					toppx: '250px',
					titletext: 'Replace Tape',
					onClicked: () => {
						this.segment1ActionTape();
					},
					disable: () => this.Action3
				},
				{
					toppx: '350px',
					titletext: 'Re-inforce Dressing',
					onClicked: () => {
						this.segment1ActionDress();
					},
					disable: () => this.Action4
				},
				{
					toppx: '450px',
					titletext: 'Contact Provider',
					onClicked: () => {
						this.segment1ActionProvider();
					},
					disable: () => this.Action5
				},
				{
					toppx: '550px',
					titletext: 'Call RRT',
					onClicked: () => {
						this.segment1ActionRRT();
					},
					disable: () => this.Action6
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action11
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action12
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action13
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action14
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action15
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1ActionAssess() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID3 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Assess Patient',
			talks: [
				{
					toppx: '50px',
					titletext: 'ECG Rythm',
					onClicked: () => {
						context.segment1ActionECG();
					},
					disable: () => this.Action21
				},
				{
					toppx: '150px',
					titletext: 'IV Insertion Site',
					onClicked: () => {
						context.segment1ActionIV();
					},
					disable: () => this.Action22
				},
				{
					toppx: '250px',
					titletext: 'Abdomen',
					onClicked: () => {
						context.segment1ActionAbdomen();
					},
					disable: () => this.Action23
				},
				{
					toppx: '350px',
					titletext: 'Surgical Site',
					onClicked: () => {
						context.segment1ActionSite();
					},
					disable: () => this.Action24
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '70px',
			loadQuiz: true,
			scenario: this,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "Horrible. Everything hurts, but especially my head.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
					// context.skipPart()
				});
			},
			quiz: [
				{
					quizheight: 5,
					quiztop: '5px',
					maxPoints: 150,
					talktext1: 'Patient Assessment',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Headache',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Nausea',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Trembling',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Sweating',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Itching',
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 5,
					prequizheight: 5,
					quiztop: '460px',
					maxPoints: 150,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Location',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'General',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Surgical Site',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Abdominal',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Head',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Chest',
							onClicked: () => {
							},
						},
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
			this.playVideoChapter(this.chapterIds.chapterCinematic58, () => {}, true);
		this.playVideoChapter(this.chapterIds.chapterCinematic64, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic58, () => {}, true);
		});
	}

	private segment1TalkRate() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: 'On a scale of 0-10, can you rate your pain?',
			isTalks: true,
			isPainScale: true,
			painScaleMaxPoints: 100,
			painScaleCorrect: 7,
			extBottom: true,
			extText: "About a seven.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				this.scenario.evaluateScoreForPainScale(updatedConfig);
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
					header: 'Pain Scale',
					list: '<li>'+updatedConfig.painAssessment+'</li>',
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				// context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic65, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic58, () => {}, true);
		});
	}

	private segment1TalkDescribe() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Can you describe your pain?',
			isTalks: true,
			extBottom: true,
			extText: "My head is throbbing, and the light is hurting my eyes.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk3 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 75,
					talktext1: 'Patient Assessment',
					talktext2: 'Pain Description',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Stabbing',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Burning',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Aching',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Throbbing',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				},
				{
					quizheight: 4,
					prequizheight: 4,
					quiztop: '410px',
					maxPoints: 75,
					talktext1: 'Patient Assessment',
					talktext2: 'Vision/Eyes',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Sensitivity to light',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Inability to focus',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Blindness in one or both eyes',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Double vision',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic66, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic58, () => {}, true);
		});
	}

	private segment1TalkForPain() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '370px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Would you like something for the pain?',
			isTalks: true,
			extBottom: true,
			extText: "No, thanks.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
					title: context.scenario.medicineAdministered,
				}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.medicineAdministered)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk4 = true;
				this.TalkCount = this.OldTalkCount - 1;
				// context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 2,
					quiztop: '5px',
					maxPoints: 100,
					talktext1: 'Medication Administered',
					talktext2: ' ',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Yes',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic67, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic58, () => {}, true);
		});
	}

	private segment1TalkWhere() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '470px',
			loadQuiz: true,
			titletext: "Do you know where you are?",
			scenario: this,
			isTalks: true,
			extBottom: true,
			extText: "In the hospital, I would guess. I think I had an accident on the way home, but I can't remember exactly",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk5 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Patient Observations',
					talktext2: 'Mental State',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Normal',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Confused',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Non-responsive',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic68, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic58, () => {}, true);
		});
	}

	private segment1TalkDay() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '570px',
			loadQuiz: true,
			titletext: 'Do you know what day it is?',
			scenario: this,
			isTalks: true,
			extBottom: true,
			extText: "Thursday?",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk6 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Patient Observation',
					talktext2: 'Mental State',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Normal',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Confused',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Non-responsive',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -500px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);

		context.scenario.displayModalPop(
			null,
            'Today is Tuesday.',
            () => {
				context.scenario.update508Window(Window508Type.TransformUI);
                context.scenario.endModalPop();
				this.playVideoChapter(this.chapterIds.chapterCinematic69, () => {
					this.playVideoChapter(this.chapterIds.chapterCinematic58, () => {}, true);
				});
            }
        );
	}

	private segment1TalkWhat() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			toppx: '670px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Do you remember what procedure you had done?',
			isTalks: true,
			extBottom: true,
			extText: "They took my spleen out, whatever that is.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}
				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk7 = true;
				this.TalkCount = this.OldTalkCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 3,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Patient Assessment',
					talktext2: 'Mental State',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Normal',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Confused',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Non-responsive',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -600px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic70, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic58, () => {}, true);
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '98.4',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action11 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
					list: '<li>Temperature : 98.4</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		context.scenario.update508Window(Window508Type.TransformUI);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Blood Pressure',
			vitaltext: '160/90',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action12 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
					list: '<li>Blood Pressure : 160/90</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Pulse',
			vitaltext: '122',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action13 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
					list: '<li>Pulse : 122</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Respirations',
			vitaltext: '24',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action14 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
					list: '<li>Respirations : 24</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			scenario: this,
			loadQuiz: true,
			titletext: 'O2 Sat Level',
			vitaltext: '98%',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action15 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcVitalsID, {
					list: '<li>02 Sat Level : 98%</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionTape() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Replaced Tape',
			isTalks: true,
			extTop: true,
			extImg: 't1', //NEED IMAGE
			extText: 'Replaced Tape',
			onSubmit: () => {
				this.Action3 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.updateScore(250);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionDress() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Re-Inforce Dressing',
			isTalks: true,
			extTop: true,
			extImg: 't2',
			extText: "You've replaced the patient's surgical dressing",
			onSubmit: () => {
				this.Action4 = true;
				this.ActionCount = this.OldActionCount - 1;
				context.scenario.updateScore(250);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.getFooterCounts();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionECG() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: 'ECG Rhythm',
			isTalks: true,
			extTop: true,
			extImg: 'ECG',
			extText: 'Normal ECG rhythm',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action21 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 500,
					talktext1: 'Patient Assessment',
					talktext2: 'ECG',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Normal Rhythm',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Amplified U wave',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Abnormal interval',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Diminished T wave',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionIV() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '170px',
			scenario: this,
			loadQuiz: true,
			titletext: 'IV Insertion Site',
			isTalks: true,
			extTop: true,
			extImg: 't0', //NEED IMAGE
			extText: 'Tape is non-intact',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action22 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 1250,
					talktext1: 'Patient Assessment',
					talktext2: 'IV Insertion Site',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Intact',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'No redness',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'No leakage',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Redness',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Leakage',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Infection',
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: 'Tape non-intact',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionAbdomen() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '270px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Abdomen',
			isTalks: true,
			extTop: true,
			extImg: 'AssessingAbdominal',
			extText: 'Abdomen feels soft and mildly distended, bowel sounds hypoactive',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action23 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 6,
					quiztop: '5px',
					maxPoints: 750,
					talktext1: 'Patient Assessment',
					talktext2: 'Abdomen',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Normal',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Distention: Mild',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Distention: Moderate',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Distention: Severe',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Bowel Sounds: Present',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Bowel Sounds: Absent',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSite() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID3);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Assess Patient',
			toppx: '370px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Surgical Site',
			isTalks: true,
			extTop: true,
			extImg: 't3',
			extText: 'Dressing tape is not intact.',
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).mcNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit1, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Action24 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID3);
				context.checkIfSubMenu2();
			},
			quiz: [
				{
					quizheight: 6,
					quiztop: '5px',
					maxPoints: 1000,
					talktext1: 'Patient Assessment',
					talktext2: 'Surgical Site',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'Clean',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Free of infection',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Bleeding',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Drainage',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Infection',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Non-intact dressing',
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0 && this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.hideFooter();
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment1Part5Debrief();
		}
		else if(this.TalkCount === 0 && this.ActionCount !== 0) {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action11 === true && this.Action12 === true && this.Action13 === true && this.Action14 === true && this.Action15 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.ActionCount = this.OldActionCount - 1;
			this.Action1 = true;
		};
		context.getFooterCounts();
	}

	private checkIfSubMenu2() {
		var context = this;
		if(this.Action21 === true && this.Action22 === true && this.Action23 === true && this.Action24 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.Action2 = true;
		};
		context.getFooterCounts();
	}

	private segment1ActionProvider() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.destroyAllUIInstances();
		this.Action5 = true;
		context.scenario.updateFooter('0', '0', true, true);
		context.scenario.hideFooter();
		this.playVideoChapter(this.chapterIds.chapterCinematic61, () => {
			context.scenario.gameManager.environment.blurFadeIn();
		});
		context.scenario.showProvider(
			"Hi Nurse, what's the situation?",
			() => {
				context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
				context.segment2showSbar();
			}
		);
	}

	private segment1ActionRRT() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.destroyAllUIInstances();
		this.Action6 = true;
		context.scenario.updateFooter('0', '0', true, true);
		context.scenario.hideFooter();
		context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
		this.playVideoChapter(this.chapterIds.chapterCinematic60, () => {
			context.scenario.gameManager.environment.blurFadeIn();
			context.segment2showSbar();
		});
	}

	private segment2showSbar() {
		var context = this;
		context.scenario.update508Window(Window508Type.SbarUI)
		this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.SbarUI, {
			s: {
				maxPoints: 150,
				options: [
					{
						text: 'Change in LOC',
						isCorrect: true
					},
					{
						text: 'Mental health disorder',
						isCorrect: false
					},
					{
						text: 'Head trauma',
						isCorrect: false
					},
					{
						text: 'Hypoglycemia',
						isCorrect: false
					}
				]
			},
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).mcBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).mcNursesID),
			r: {
				maxPoints: 200,
				options: [
					{
						text: 'Medication',
						isCorrect: false
					},
					{
						text: 'Labs',
						isCorrect: true
					},
					{
						text: 'CT Scan',
						isCorrect: true
					}
				]
			},
			correctFeedback: 'Good job, you have correctly relayed critical information. Please review the SBAR and continue.',
			incorrectFeedback: 'You have incorrectly relayed critical information. Accurate patient information ensures patient safety and quality care provided by medical staff and Providers. Please continue to review the corrected SBAR.',
			onSubmitted: (result: SbarUIConfig) => {
				this.scenario.evaluateScoreForSbar(result);
			},
			onClose: (result: SbarUIConfig) => {
				context.scenario.destroyAllUIInstances();
				if(this.Action5 === true) {
					context.scenario.showProvider(
						"Thanks for the update. I am ordering Labs and a CT scan",
						() => {
							context.segment1Part5Debrief();
						}
					);
				}
				else {
					context.scenario.showProvider(
						"Okay we will take Ms. McLoughlin to get Labs and CT scans.",
						() => {
							context.segment1Part5Debrief();
						}
					);
				}
			},
			onSetWindow: (window: Window508Type) => {
				context.scenario.update508Window(window);
			}
		});
	}
}